var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter"},[_c('EyeIcon'),_vm._v("  "+_vm._s(_vm.$formatNum(_vm.post.viewCount))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }